import React, { useState, useEffect, memo } from 'react'
import dynamic from 'next/dynamic'
import { IntlShape } from 'react-intl'
import useAuth from '@/hooks/auth'
import { SoundProps } from '../../../../types/sound'
import Sound from './sound'


interface EditProps {
  defaultSound: SoundProps
  toggleEdit: () => void
  onUpdate: (sound: SoundProps) => void
  addMessage?: (message: string) => void
  intl?: IntlShape
}
const SoundEdit = dynamic<EditProps>(() => import('./edit'), { ssr: false })

interface Props {
  sound: SoundProps
  buy: boolean
}

const SoundContainer = ({ buy, ...props }: Props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const [ sound, setSound ] = useState(props.sound)
  const [ isEdit, setEdit ] = useState(false)

  const { currentUser: currUser, loggedin } = useAuth()
  const currentUser = loggedin ? currUser : { username: '' }

  const isMine = sound.user.username === currentUser.username
  const onSoundUpdate = (data) => {
    setSound({ ...sound, ...data })
    setEdit(false)
  }

  useEffect(() => {
    setSound(props.sound)
    setEdit(false)
  }, [
    // eslint-disable-next-line react/destructuring-assignment
    props.sound,
  ])

  return isEdit ? (
    <SoundEdit
      defaultSound={sound}
      toggleEdit={() => setEdit(false)}
      onUpdate={onSoundUpdate}
    />
  ) : (
    <Sound
      defaultSound={sound}
      isMine={isMine}
      toggleEdit={() => setEdit(true)}
      openBuy={buy}
      isAdmin={!!currentUser && currentUser.role === 'admin'}
    />
  )
}

export default memo(SoundContainer)
